







import Vue, { PropOptions } from 'vue';
import PermissionMixin from '../../mixins/Permission.mixin';

import {
  AppRoute,
} from '../../data/routes';

const navComponents = {
  link: () => import('../SSidebarLink/SSidebarLink.vue'),
  section: () => import('./SectionHeading/SectionHeading.vue'),
  group: () => import('../SSidebarGroup/SSidebarGroup.vue'),
};

export default Vue.extend({
  name: 'SNavigationItem',
  mixins: [PermissionMixin],
  props: {
    item: {
      required: true,
      type: Object,
    } as PropOptions<AppRoute>,
    index: {
      required: false,
      type: Number,
    },
  },
  data(): any {
    return {};
  },
  computed: {
    component(): any {
      return navComponents[this.item.type];
    },
    props(): any {
      switch (this.item.type) {
        case 'link':
          return {
            icon: this.item.icon,
            title: this.item.title,
            to: this.item.link,
            exact: this.item.exact,
          };
        case 'section':
          return {
            title: this.item.title,
            showDivider: this.index !== 0,
            action: this.sectionHeadingAction,
          };
        case 'group':
          return {
            title: this.item.heading,
            icon: this.item.icon,
            routes: this.item.routes,
          };
        default:
          return {};
      }
    },
    sectionHeadingAction(): any {
      if (this.item.type !== 'section' || !this.item.action) {
        return null;
      }

      if (this.item.action.permissions) {
        return this.hasPermissions(...this.item.action.permissions)
          ? this.item.action.action
          : null;
      }

      return this.item.action;
    },
  },
});
